import { Component } from '@angular/core';

@Component({
  selector: 'app-general-terms-page',
  template: `
    <app-page-section padding="sm">
      <div class="text-center">
        <h1>Conditions générales</h1>
        <app-spacer></app-spacer>
        <p>
          <strong>Solution web location-salles.ch</strong><br />
          Dernière mise à jour : 27 mars 2026
        </p>
      </div>
    </app-page-section>

    <app-page-section padding="none">
      <div class="prose">
        <!-- Table des matières -->
        <nav class="toc">
          <h2>Table des matières</h2>
          <ol>
            <li>
              <a [routerLink]="[]" fragment="definitions">Définitions</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="objet">Objet du contrat</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="abonnements"
                >Formules d'abonnement</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="tarification">Tarification</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="droits-utilisation"
                >Droits d'utilisation</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="donnees"
                >Hébergement des données</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="obligations"
                >Obligations de l'Hôte</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="locataires"
                >Relation avec les Locataires</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="paiement">Modalités de paiement</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="duree">Durée et résiliation</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="support">Support et assistance</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="responsabilite"
                >Garantie et responsabilité</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="confidentialite"
                >Confidentialité et protection des données</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="propriete-intellectuelle"
                >Propriété intellectuelle</a
              >
            </li>
            <li>
              <a [routerLink]="[]" fragment="dispositions-generales"
                >Dispositions générales</a
              >
            </li>
          </ol>
        </nav>

        <app-spacer size="8"></app-spacer>

        <!-- Introduction -->
        <p>
          En créant un compte sur location-salles.ch ou en passant commande de
          services, le Client accepte sans réserve les présentes Conditions
          générales (ci-après « CG »).
        </p>

        <!-- Article 1 : Définitions -->
        <h2 id="definitions">1. Définitions</h2>
        <ul>
          <li>
            <strong>Hôte (ou Client) :</strong> toute personne physique ou
            morale qui souscrit un abonnement à location-salles.ch et met ses
            salles à disposition pour la location. L'Hôte est le seul
            contractant avec le Fournisseur.
          </li>
          <li>
            <strong>Locataire :</strong> toute personne qui réserve une salle
            auprès d'un Hôte via la plateforme location-salles.ch. Le Locataire
            n'a aucune relation contractuelle directe avec le Fournisseur
            concernant la location de salles.
          </li>
          <li>
            <strong>Fournisseur :</strong> Ercos SA, dont le siège social est
            situé au Chemin en Cormistaux 92A, 1040 Echallens.
          </li>
          <li>
            <strong>Salle publique :</strong> salle rendue accessible à la
            location pour des tiers, qu'elle soit proposée gratuitement, sur
            facturation manuelle ou avec paiement en ligne intégré.
          </li>
          <li>
            <strong>Salle interne :</strong> salle utilisée uniquement pour des
            réservations internes de l'Hôte, sans mise à disposition pour des
            tiers.
          </li>
          <li>
            <strong>Groupe de salles :</strong> ensemble de salles pouvant être
            réservées individuellement ou conjointement, dont la réservation de
            l'une peut entraver la disponibilité des autres.
          </li>
        </ul>

        <!-- Article 2 : Objet du contrat -->
        <h2 id="objet">2. Objet du contrat</h2>

        <h3>2.1 Services fournis</h3>
        <p>
          Le Fournisseur délivre des prestations de services SaaS (Software as a
          Service) via Internet dans le domaine de la gestion de location de
          salles et d'espaces. L'objet du présent contrat comprend :
        </p>
        <ul>
          <li>
            La mise à disposition du logiciel location-salles.ch via Internet
          </li>
          <li>L'hébergement et la sauvegarde des données de l'Hôte</li>
          <li>La maintenance et l'évolution du logiciel</li>
          <li>Le support technique selon la formule d'abonnement choisie</li>
        </ul>

        <h3>2.2 Maintenance</h3>
        <p>
          Le Fournisseur s'engage à améliorer continuellement le logiciel et à
          mettre ces améliorations à la disposition de l'Hôte par le biais de
          mises à jour régulières. Le Fournisseur corrige également les erreurs
          logicielles dans la mesure du techniquement possible et
          raisonnablement exigible. Une erreur désigne tout dysfonctionnement
          empêchant ou réduisant significativement l'utilisation normale du
          logiciel.
        </p>

        <!-- Article 3 : Formules d'abonnement -->
        <h2 id="abonnements">3. Formules d'abonnement</h2>

        <h3>3.1 Plan Gratuit</h3>
        <p>
          Le plan Gratuit est destiné aux organisations souhaitant gérer
          uniquement leurs réservations internes. Il permet de créer un nombre
          illimité d'utilisateurs, de salles internes et de réservations. En
          revanche, la mise en location publique de salles (qu'elles soient
          gratuites ou payantes) n'est pas disponible dans cette formule. Le
          paiement en ligne n'est également pas disponible.
        </p>

        <h3>3.2 Abonnement Annuel</h3>
        <p>
          L'abonnement annuel permet la mise en location publique de salles,
          avec ou sans paiement en ligne intégré. Cette formule est obligatoire
          dès lors qu'une ou plusieurs salles sont rendues accessibles à des
          tiers, qu'elles soient proposées gratuitement, sur facturation
          manuelle ou avec paiement en ligne intégré. Elle est idéale pour les
          Hôtes souhaitant proposer leurs espaces à la location de manière
          professionnelle. Les détails tarifaires sont disponibles dans la
          <a [routerLink]="[]" fragment="tarification">section Tarification</a>.
        </p>

        <h3>3.3 Abonnement à la Commission</h3>
        <p>
          L'abonnement à la commission permet également la mise en location
          publique de salles, avec une facturation basée sur un pourcentage des
          réservations payantes. Une commission de 15% est automatiquement
          déduite par le fournisseur de paiement avant le versement à l'Hôte.
        </p>
        <p>
          <strong>Condition d'éligibilité :</strong> Cette formule est
          uniquement disponible pour les Hôtes dont toutes les salles publiques
          sont payantes. Dès qu'une salle publique est
          proposée gratuitement, l'Hôte doit obligatoirement souscrire un
          abonnement annuel.
        </p>

        <h3>3.4 Utilisation des salles internes</h3>
        <p>
          Les salles internes sont destinées exclusivement aux réservations
          internes de l'Hôte, quelle que soit la formule d'abonnement souscrite.
          Toute utilisation de salles internes pour des locations facturées à
          des tiers en dehors de la plateforme constitue une violation des
          présentes Conditions générales.
        </p>

        <h3 id="verification-conformite">3.5 Vérification de conformité</h3>
        <p>
          Le Fournisseur se réserve le droit de procéder à des vérifications
          régulières afin de s'assurer du respect des conditions d'utilisation
          liées à chaque formule d'abonnement. En cas de non-conformité
          constatée, le Fournisseur notifiera l'Hôte par écrit et lui accordera
          un délai de 90 jours pour régulariser sa situation. À défaut de
          régularisation dans ce délai, le Fournisseur pourra procéder à une
          facturation rétroactive des montants dus ou résilier le contrat
          conformément à
          l'<a [routerLink]="[]" fragment="resiliation-immediate">article 10.3</a
          >.
        </p>

        <!-- Article 4 : Tarification -->
        <h2 id="tarification">4. Tarification</h2>

        <h3>4.1 Abonnement Annuel</h3>
        <table>
          <tbody>
            <tr>
              <td>Licence annuelle de base (1 salle publique incluse)</td>
              <td>CHF 1'150.- HT/an</td>
            </tr>
            <tr>
              <td>Frais de mise en service (unique, 1re année)</td>
              <td>CHF 500.- HT</td>
            </tr>
            <tr>
              <td>Salles supplémentaires (1-10)</td>
              <td>CHF 400.- HT/salle/an</td>
            </tr>
            <tr>
              <td>Salles supplémentaires (11-20)</td>
              <td>CHF 300.- HT/salle/an</td>
            </tr>
            <tr>
              <td>Salles supplémentaires (21+)</td>
              <td>CHF 200.- HT/salle/an</td>
            </tr>
          </tbody>
        </table>
        <p>
          La licence annuelle inclut les frais d'abonnement
          du fournisseur de paiement en ligne Payrexx, à un tarif préférentiel
          de CHF 250.- par an.
        </p>

        <h3>4.2 Groupes de salles</h3>
        <p>
          Les salles faisant partie d'un groupe de salles bénéficient d'un tarif
          réduit de 50% par rapport au tarif standard. Cette réduction
          s'applique car la réservation d'une salle du groupe peut entraver la
          disponibilité des autres salles. Les tarifs sont donc de CHF 200.-,
          150.- ou 100.- par salle et par an selon le palier applicable.
        </p>

        <h3>4.3 Abonnement à la Commission</h3>
        <table>
          <tbody>
            <tr>
              <td>Commission sur réservations payantes</td>
              <td>15%</td>
            </tr>
            <tr>
              <td>Frais de mise en service (unique, 1re année)</td>
              <td>CHF 500.- HT</td>
            </tr>
          </tbody>
        </table>

        <h3>4.4 Options</h3>
        <p>Les prestations suivantes peuvent être commandées en supplément :</p>
        <table>
          <tbody>
            <tr>
              <td>Intégration Dormakaba - mise en service par salle</td>
              <td>CHF 300.- HT</td>
            </tr>
            <tr>
              <td>Intégration Dormakaba - abonnement par salle et par an</td>
              <td>CHF 200.- HT</td>
            </tr>
            <tr>
              <td>Formation des collaborateurs (jusqu'à une demi-journée)</td>
              <td>CHF 500.- HT</td>
            </tr>
            <tr>
              <td
                >Importation des réservations existantes (via export Excel)</td
              >
              <td>CHF 300.- HT</td>
            </tr>
          </tbody>
        </table>
        <p>
          <em
            >Note : Les tarifs de l'intégration Dormakaba sont applicables sur
            les nouveaux abonnements à partir du 1er janvier 2026.</em
          >
        </p>

        <h3>4.5 Activation en cours d'année</h3>
        <p>
          Lors de l'activation d'une nouvelle salle publique en cours
          d'abonnement annuel, le montant correspondant est facturé
          immédiatement au prorata temporis, selon les tarifs en vigueur.
        </p>

        <h3>4.6 Modifications tarifaires</h3>
        <p>
          Le Fournisseur se réserve le droit de modifier les tarifs avec effet à
          la prochaine échéance de renouvellement du contrat. Les Hôtes seront
          informés de toute modification par écrit. En cas de modification
          tarifaire substantielle, l'Hôte peut résilier le contrat avec un
          préavis de 30 jours à compter de la notification.
        </p>

        <!-- Article 5 : Droits d'utilisation -->
        <h2 id="droits-utilisation">5. Droits d'utilisation</h2>

        <h3>5.1 Licence</h3>
        <p>
          Le Fournisseur accorde à l'Hôte un droit d'utilisation non exclusif et
          non transmissible du logiciel location-salles.ch pour la durée du
          contrat. Cette licence est strictement personnelle et ne peut être
          transférée ou sous-licenciée à des tiers sans l'accord écrit préalable
          du Fournisseur.
        </p>

        <h3>5.2 Restrictions</h3>
        <p>
          Dans le cadre de cette licence, l'Hôte s'interdit expressément de :
        </p>
        <ul>
          <li
            >Reproduire, copier ou modifier le logiciel de quelque manière que
            ce soit</li
          >
          <li
            >Mettre le logiciel à disposition de tiers, que ce soit à titre
            gratuit ou onéreux, en dehors de l'utilisation normale du
            service</li
          >
          <li
            >Procéder à de la rétro-ingénierie, décompiler ou désassembler le
            logiciel</li
          >
          <li
            >Utiliser le logiciel pour développer un produit concurrent ou
            similaire</li
          >
        </ul>

        <h3>5.3 Intégrations tierces</h3>
        <p>
          L'Hôte a la possibilité de commander des modules complémentaires
          (add-ons) nécessitant l'intégration de services tiers. En commandant
          un tel add-on, l'Hôte accepte d'octroyer tous les droits d'accès
          nécessaires au bon fonctionnement de l'intégration. Le Fournisseur ne
          peut être tenu responsable du fonctionnement ou de la disponibilité
          des services tiers intégrés via ces add-ons.
        </p>

        <!-- Article 6 : Hébergement des données -->
        <h2 id="donnees">6. Hébergement des données</h2>

        <h3>6.1 Hébergement</h3>
        <p>
          Les données sont hébergées auprès d'Infomaniak SA à Genève, en Suisse.
          Le Fournisseur veille à ce que les données puissent être consultées
          dans la mesure du techniquement possible et raisonnablement exigible.
          Toutefois, le Fournisseur ne peut garantir une disponibilité absolue
          du service en raison de contraintes techniques inhérentes à Internet
          et aux infrastructures informatiques.
        </p>

        <h3>6.2 Sécurité</h3>
        <p>
          Le Fournisseur s'engage à prendre les dispositions adéquates et
          raisonnables pour protéger les données contre la perte, la corruption
          et les accès non autorisés de tiers. Des sauvegardes régulières sont
          effectuées afin d'assurer la pérennité des données. L'Hôte reconnaît
          toutefois qu'aucun système informatique n'est totalement infaillible.
        </p>

        <h3>6.3 Propriété des données</h3>
        <p>
          L'Hôte reste propriétaire de l'ensemble des données qu'il stocke sur
          la plateforme, y compris les données relatives aux Locataires. L'Hôte
          peut exiger du Fournisseur la restitution de ses données à tout moment
          pendant la durée du contrat, sans que le Fournisseur ne puisse exercer
          un droit de rétention.
        </p>

        <h3>6.4 Restitution après résiliation</h3>
        <p>
          Après résiliation du contrat, l'Hôte dispose d'un délai de 30 jours
          pour réclamer la restitution de ses données. Au-delà de ce délai, le
          Fournisseur n'est plus tenu de conserver les données. Si les données
          sont encore disponibles, leur restitution reste possible contre
          paiement des frais effectivement encourus.
        </p>

        <!-- Article 7 : Obligations de l'Hôte -->
        <h2 id="obligations">7. Obligations de l'Hôte</h2>

        <h3>7.1 Sécurité des accès</h3>
        <p>
          L'Hôte est tenu de prendre toutes les mesures nécessaires pour
          protéger ses identifiants de connexion. Il doit conserver ses
          identifiants secrets, modifier son mot de passe au minimum tous les 60
          jours, et informer immédiatement le Fournisseur de toute utilisation
          non autorisée de son compte ou de toute autre violation de la
          sécurité.
        </p>

        <h3>7.2 Utilisation conforme</h3>
        <p>
          L'Hôte s'engage à utiliser le logiciel conformément à sa destination
          et aux présentes Conditions générales. Il est personnellement
          responsable de la saisie et du traitement des données, ainsi que de
          toutes les actions effectuées via son compte, y compris celles
          réalisées par les utilisateurs qu'il a autorisés.
        </p>

        <h3>7.3 Indemnisation</h3>
        <p>
          L'Hôte s'engage à dégager le Fournisseur de toute responsabilité et à
          prendre en charge tous les frais encourus (frais d'avocat, dommages et
          intérêts, frais de procédure) en cas de réclamation de tiers résultant
          notamment de :
        </p>
        <ul>
          <li
            >Contenus illégaux ou illicites stockés ou diffusés via la
            plateforme</li
          >
          <li
            >Violation de droits de tiers (droits d'auteur, données
            personnelles, etc.)</li
          >
          <li>Litiges entre l'Hôte et ses Locataires</li>
          <li>Non-respect des lois et règlements en vigueur</li>
        </ul>

        <!-- Article 8 : Relation avec les Locataires -->
        <h2 id="locataires">8. Relation avec les Locataires</h2>
        <p>
          Le Fournisseur n'entretient aucune relation contractuelle directe avec
          les Locataires concernant la location de salles. La seule relation
          contractuelle existe entre l'Hôte et le Fournisseur d'une part, et
          entre l'Hôte et ses Locataires d'autre part.
        </p>
        <p>
          L'Hôte est seul responsable de ses relations avec les Locataires,
          notamment en ce qui concerne les conditions de location, les tarifs
          appliqués, les conditions d'annulation et de remboursement, la qualité
          des salles et équipements, le support client, ainsi que tout litige
          éventuel. L'Hôte reste également propriétaire et responsable des
          données de ses Locataires collectées via la plateforme, le Fournisseur
          agissant uniquement en qualité d'hébergeur technique.
        </p>

        <!-- Article 9 : Modalités de paiement -->
        <h2 id="paiement">9. Modalités de paiement</h2>

        <h3>9.1 Échéances</h3>
        <p>
          L'Hôte s'engage à payer au Fournisseur la rémunération convenue selon
          la formule d'abonnement choisie, majorée de la TVA au taux légal en
          vigueur. Les échéances de paiement sont les suivantes :
        </p>
        <ul>
          <li>
            <strong>Abonnement annuel :</strong> Paiement au prorata à la
            signature du contrat pour la première année, puis annuellement au
            1er janvier de chaque année.
          </li>
          <li>
            <strong>Abonnement à la commission :</strong> La commission de 15%
            est automatiquement déduite par Payrexx avant le versement à l'Hôte.
          </li>
          <li>
            <strong>Frais de mise en service :</strong> Facturés une seule fois
            lors de la première année, payables à la signature du contrat.
          </li>
        </ul>

        <h3>9.2 Délais et retards</h3>
        <p>
          Les factures sont payables dans un délai de 30 jours à compter de leur
          date d'émission. En cas de retard de paiement, un intérêt moratoire de
          5% par an sera appliqué dès le 31e jour suivant la date d'échéance,
          sans mise en demeure préalable. Si le paiement n'est pas effectué dans
          les 14 jours suivant une mise en demeure, le Fournisseur se réserve le
          droit de suspendre l'accès aux services ou de résilier le contrat.
        </p>

        <!-- Article 10 : Durée et résiliation -->
        <h2 id="duree">10. Durée et résiliation</h2>

        <h3>10.1 Durée</h3>
        <p>
          La relation contractuelle débute avec l'inscription de l'Hôte sur
          location-salles.ch ou avec la signature du contrat d'adhésion. Les
          abonnements sont conclus pour une durée indéterminée et se
          renouvellent automatiquement par tacite reconduction.
        </p>

        <h3>10.2 Résiliation ordinaire</h3>
        <p>
          Chaque partie peut résilier le contrat selon les modalités suivantes :
        </p>
        <ul>
          <li>
            <strong>Abonnement annuel :</strong> Résiliation possible avec un
            préavis de 15 jours avant la prochaine échéance de renouvellement
            (31 décembre).
          </li>
          <li>
            <strong>Abonnement à la commission :</strong> Résiliation possible
            avec un préavis de 30 jours pour la fin d'un mois civil.
          </li>
        </ul>
        <p>
          La résiliation doit être effectuée par email à contact&#64;ercos.ch ou
          par téléphone au 021 525 30 60.
        </p>

        <h3 id="resiliation-immediate">10.3 Résiliation immédiate</h3>
        <p>
          Chaque partie peut résilier le contrat avec effet immédiat pour de
          justes motifs. Le Fournisseur reconnaît notamment les circonstances
          suivantes comme justes motifs :
        </p>
        <ul>
          <li
            >Faillite de l'Hôte ou requête de mise en faillite à son
            encontre</li
          >
          <li
            >Défaut de paiement persistant malgré une mise en demeure restée
            infructueuse pendant 14 jours</li
          >
          <li
            >Violation des droits d'auteur, de propriété intellectuelle ou
            d'autres droits de tiers</li
          >
          <li
            >Utilisation des services à des fins illégales ou contraires à
            l'éthique</li
          >
          <li
            >Violation grave ou répétée des présentes Conditions générales (cf.
            <a [routerLink]="[]" fragment="verification-conformite">article 3.5</a
            >)</li
          >
        </ul>

        <h3>10.4 Effets</h3>
        <p>
          En cas de résiliation du contrat, l'accès de l'Hôte au logiciel est
          immédiatement suspendu à la date effective de résiliation. L'Hôte peut
          réclamer la restitution de ses données dans un délai de 30 jours
          conformément à l'<a [routerLink]="[]" fragment="donnees"
            >article 6.4</a
          >. Aucun remboursement au prorata ne sera effectué pour les périodes
          d'abonnement déjà payées.
        </p>

        <!-- Article 11 : Support -->
        <h2 id="support">11. Support et assistance</h2>

        <h3>11.1 Support inclus</h3>
        <p>
          Le Fournisseur s'engage à traiter les questions et demandes de l'Hôte
          en rapport avec le logiciel dans les meilleurs délais. Chaque
          abonnement payant inclut une heure de support technique par an. Les
          demandes peuvent être adressées par email à support&#64;ercos.ch ou
          par téléphone. Le support fourni par le Fournisseur concerne
          uniquement les problèmes techniques liés au logiciel ; l'assistance
          aux Locataires et utilisateurs finaux est assurée par l'Hôte.
        </p>

        <h3>11.2 Tarifs supplémentaires</h3>
        <p>
          Les heures de support au-delà de l'heure incluse dans l'abonnement
          sont facturées au tarif de CHF 165.- HT par heure.
        </p>

        <h3>11.3 Disponibilité</h3>
        <p>
          Le support est disponible du lundi au vendredi, de 8h à 17h, hors
          jours fériés du Canton de Vaud. Le Fournisseur avertit les Hôtes des travaux de
          maintenance planifiés et s'efforce de minimiser les interruptions de
          service.
        </p>

        <!-- Article 12 : Garantie et responsabilité -->
        <h2 id="responsabilite">12. Garantie et responsabilité</h2>

        <h3>12.1 Disponibilité</h3>
        <p>
          Le Fournisseur garantit le bon état de fonctionnement et la
          disponibilité des services dans la mesure du raisonnablement exigible
          et du techniquement possible. Toutefois, une disponibilité absolue ne
          peut être garantie en raison des contraintes techniques inhérentes à
          Internet et aux infrastructures d'hébergement.
        </p>

        <h3>12.2 Blocage pour contenu illicite</h3>
        <p>
          Le Fournisseur est autorisé à bloquer immédiatement l'accès aux
          services s'il existe des raisons fondées de penser que les données
          stockées sont illégales ou portent atteinte aux droits de tiers. Le
          Fournisseur informera immédiatement l'Hôte de cette restriction et de
          ses motifs. Le blocage sera levé dès que les soupçons seront infirmés.
        </p>

        <h3>12.3 Limitation de responsabilité</h3>
        <p>
          Dans le cadre des dispositions légales, le Fournisseur décline toute
          responsabilité pour les dommages indirects, notamment la perte de
          données, le manque à gagner, les dommages consécutifs et
          l'interruption d'activité. Cette limitation s'applique sauf en cas de
          faute grave ou intentionnelle du Fournisseur.
        </p>

        <h3>12.4 Plafonnement</h3>
        <p>
          Dans tous les cas, la responsabilité du Fournisseur envers l'Hôte est
          limitée au montant des redevances effectivement payées par l'Hôte au
          cours des douze derniers mois précédant la survenance du dommage.
        </p>

        <!-- Article 13 : Confidentialité -->
        <h2 id="confidentialite"
          >13. Confidentialité et protection des données</h2
        >

        <h3>13.1 Engagement</h3>
        <p>
          Le Fournisseur s'engage à garder strictement confidentielles toutes
          les informations portées à sa connaissance dans le cadre de
          l'exécution du contrat, en particulier les secrets commerciaux ou
          industriels de l'Hôte. Ces informations ne seront communiquées à des
          tiers qu'avec l'autorisation préalable de l'Hôte ou si cela s'avère
          nécessaire à l'accomplissement des obligations contractuelles
          (hébergeur, fournisseur de paiement).
        </p>

        <h3>13.2 Accès aux données</h3>
        <p>
          Les données confidentielles, notamment les coordonnées des Locataires,
          sont accessibles uniquement via le compte de l'Hôte et par les
          utilisateurs dûment autorisés. Le Fournisseur n'accède aux données de
          l'Hôte qu'avec son autorisation explicite, généralement dans le cadre
          d'une assistance technique.
        </p>

        <h3>13.3 Communications</h3>
        <p>
          Le Fournisseur peut ajouter les administrateurs et le personnel de
          l'Hôte à sa base de contacts afin de les informer des nouveautés et
          mises à jour du logiciel. Les données des Locataires ne sont jamais
          incluses dans cette base de données et ne font l'objet d'aucune
          exploitation commerciale.
        </p>

        <h3>13.4 Protection des données</h3>
        <p>
          Le traitement des données personnelles est effectué conformément à la
          Loi fédérale sur la protection des données (LPD) et au Règlement
          général sur la protection des données (RGPD) lorsque applicable. En
          acceptant les présentes Conditions générales, l'Hôte accepte également
          la Politique de confidentialité disponible sur location-salles.ch.
        </p>

        <h3>13.5 Sécurité</h3>
        <p>
          L'Hôte a la possibilité d'activer l'authentification à deux facteurs
          pour renforcer la sécurité de l'accès à son compte. Le site utilise
          par ailleurs un système de gestion des consentements relatifs aux
          cookies, conforme à la législation en vigueur, fourni par Biskoui.ch.
        </p>

        <h3>13.6 Référence commerciale</h3>
        <p>
          Le Fournisseur est autorisé à citer l'Hôte comme référence à des fins
          de marketing et de vente, de manière appropriée. L'Hôte peut s'opposer
          à cette utilisation en adressant une notification écrite à
          contact&#64;ercos.ch.
        </p>

        <!-- Article 14 : Propriété intellectuelle -->
        <h2 id="propriete-intellectuelle">14. Propriété intellectuelle</h2>

        <h3>14.1 Droits du Fournisseur</h3>
        <p>
          Tous les droits de propriété intellectuelle relatifs au logiciel
          location-salles.ch, à ses fonctionnalités, à son code source, à sa
          documentation et à tous les éléments qui le composent demeurent
          l'entière propriété du Fournisseur. L'Hôte dispose uniquement d'un
          droit d'utilisation tel que défini à l'<a
            [routerLink]="[]"
            fragment="droits-utilisation"
            >article 5</a
          >, sans aucune cession de droits de propriété intellectuelle.
        </p>

        <h3>14.2 Droits de l'Hôte</h3>
        <p>
          L'Hôte conserve l'entière propriété de toutes les données qu'il stocke
          sur la plateforme, y compris les informations relatives à ses salles,
          les données de ses Locataires, les réservations et transactions, ainsi
          que les contenus qu'il publie. Le Fournisseur s'engage à restituer ces
          données conformément à l'<a [routerLink]="[]" fragment="donnees"
            >article 6</a
          >.
        </p>

        <h3>14.3 Marques</h3>
        <p>
          Les marques, logos et signes distinctifs « location-salles.ch » et «
          Ercos » sont la propriété exclusive du Fournisseur et ne peuvent être
          utilisés par l'Hôte sans autorisation écrite préalable. L'Hôte
          conserve de même la propriété de ses propres marques et logos.
        </p>

        <!-- Article 15 : Dispositions générales -->
        <h2 id="dispositions-generales">15. Dispositions générales</h2>

        <h3>15.1 Modification des CG</h3>
        <p>
          Le Fournisseur se réserve le droit de modifier les présentes
          Conditions générales à tout moment. Les modifications entrent en
          vigueur dès leur publication sur le site location-salles.ch. Le
          Fournisseur informera les Hôtes par email de toute modification
          substantielle avec un délai de préavis raisonnable.
        </p>

        <h3>15.2 Communications</h3>
        <p>
          Toutes les communications entre les parties doivent être effectuées
          par écrit aux adresses indiquées lors de l'enregistrement. Les
          transmissions par email satisfont aux exigences de la forme écrite.
          Chaque partie est tenue d'informer l'autre de tout changement
          d'adresse, faute de quoi les communications envoyées à la dernière
          adresse connue seront réputées valablement transmises.
        </p>

        <h3>15.3 Clause de sauvegarde</h3>
        <p>
          En cas d'invalidité totale ou partielle d'une clause des présentes
          Conditions générales, les autres dispositions restent pleinement
          applicables. La clause invalide sera réinterprétée ou remplacée de
          manière à atteindre l'objectif économique initialement recherché.
        </p>

        <h3>15.4 Intégralité</h3>
        <p>
          Les présentes Conditions générales, conjointement avec le contrat
          d'adhésion éventuel et la Politique de confidentialité, constituent
          l'intégralité de l'accord entre les parties. Aucune condition
          différente proposée par l'Hôte ne sera applicable sans accord écrit du
          Fournisseur.
        </p>

        <h3>15.5 Droit applicable et for</h3>
        <p>
          Les présentes Conditions générales et toutes les relations
          contractuelles qui en découlent sont soumises au droit suisse. Pour
          tout litige découlant du présent contrat, les tribunaux de Lausanne
          sont exclusivement compétents.
        </p>

        <h3>15.6 Contact</h3>
        <p>
          location-salles.ch est un service Internet de :<br /><br />
          <strong>Ercos SA</strong><br />
          Chemin en Cormistaux 92A<br />
          1040 Echallens<br />
          Suisse<br />
          Email : contact&#64;ercos.ch<br />
          Téléphone : 021 525 30 60
        </p>
      </div>
    </app-page-section>
  `,
  standalone: false,
})
export class GeneralTermsPageComponent {}
